// Unpublished Work © 2022-2024 Deere & Company.

export const MY_JOHN_DEERE = 'MyJohnDeere';
export const ONLINK = 'OnLink';
export const JOHN_DEERE = 'John Deere';
export const POGO = 'POGO';
